import React, { PureComponent } from "react";
import { connect } from "react-redux";
import firebase from "firebase/app";
import { Link, withRouter } from "react-router-dom";
import proximanova_light from "../assets/fonts/Proxima_Nova_Alt_Light.otf";
import "../css/requestForm.css";
import "firebase/auth";
import axios from "axios";
import {
  onASEmailChange,
  onASPassword1Change,
  onASPassword2Change,
  attemptAccountSetup,
  onASNameChange,
  onASClearFields,
  onASError,
  addToken,
} from "../actions";
import { Form } from "react-bootstrap";
import { createOAuthHeader521 } from "../actions/types";

class SignUp extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      forgotPasswordClicked: false,
      forgotPasswordMessage: "",
    };
  }

  UNSAFE_componentWillMount() {
    this.props.onASClearFields();
  }

  checkForEmail = async () => {
    try {
      let AUTHORIZATION_HEADER = createOAuthHeader521(
        "GET",
        "521",
        "1",
        this.props.email
      );
      let checkEmailResponse = await axios.get(
        "https://secret-retreat-76675.herokuapp.com/api/auth/email",
        {
          params: {
            email: this.props.email,
            auth_header: AUTHORIZATION_HEADER,
          },
        }
      );
      let data = checkEmailResponse.data;
      let numberOfRecords = data.searchResults.length;
      return {
        success: true,
        numberOfRecords,
        firstName: data.recordDetails.entityid,
        accountId: data.recordDetails.company.internalid,
        accountName: data.recordDetails.company.name,
        contactId: data.recordDetails.id,
      };
    } catch (err) {
      console.log("checkForEmail err", err);
      return { success: false, error: err };
    }
  };
  attemptCreateAccount = async () => {
    this.props.attemptAccountSetup();
    // 1) Check if e-mail is null
    if (this.props.email === "") {
      this.props.onASError("Please enter a valid email.");
      return;
    }

    let emailCheckResponse = await this.checkForEmail();
    // Error on call
    if (!emailCheckResponse.success) {
      this.props.onASError(
        "Error Creating Account. E-mail address is not in our system."
      );
      return;
    }
    // Call was successful
    else {
      // E-mail is NOT in NetSuite
      if (emailCheckResponse.numberOfRecords === 0) {
        this.props.onASError("E-mail address is not in our system.");
        return;
      } else {
      }
    }
    // E-mail is in Salesforce, now check if pw1 or pw2 is null
    if (this.props.password1 === "" || this.props.password2 === "") {
      this.props.onASError("Password cannot be blank.");
      return;
    }

    // Check if pw1 matches pw2
    if (this.props.password1 !== this.props.password2) {
      this.props.onASError("Passwords must match.");
      return;
    }
    // Try and create user in firebase

    try {
      await firebase
        .auth()
        .createUserWithEmailAndPassword(this.props.email, this.props.password1);

      let user = firebase.auth().currentUser;
      await user.updateProfile({
        displayName: this.props.displayName,
      });
      user.sendEmailVerification();
      localStorage.setItem("signedUp", true);
      this.props.onASNameChange(emailCheckResponse.firstName);
    } catch (error) {
      this.props.onASError("Error Creating Account in Firebase");
      return;
    }
  };
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <p
          className="welcome"
          style={{
            marginTop: "30px",
            fontSize: "36px",
            letterSpacing: 0.4,
          }}
        >
          CREATE PROFILE
        </p>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.attemptCreateAccount();
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: 200,
            }}
          >
            <Form.Group className="form_item">
              <Form.Control
                type="email"
                placeholder="EMAIL"
                value={this.props.email}
                onChange={(text) =>
                  this.props.onASEmailChange(text.target.value)
                }
                style={{
                  textAlign: "center",
                  minWidth: "300px",
                  padding: "10px",
                  height: "60px",
                  border: "2px #EFEFEF solid",
                  fontFamily: proximanova_light,
                }}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="form_item">
              <Form.Control
                type="password"
                placeholder="PASSWORD"
                value={this.props.password1}
                onChange={(text) =>
                  this.props.onASPassword1Change(text.target.value)
                }
                style={{
                  textAlign: "center",
                  minWidth: "300px",
                  padding: "10px",
                  height: "60px",
                  border: "2px #EFEFEF solid",
                  fontFamily: proximanova_light,
                }}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="form_item">
              <Form.Control
                type="password"
                placeholder="CONFIRM PASSWORD"
                value={this.props.password2}
                onChange={(text) =>
                  this.props.onASPassword2Change(text.target.value)
                }
                style={{
                  textAlign: "center",
                  minWidth: "300px",
                  // width: "40vw",
                  padding: "10px",
                  height: "60px",
                  border: "2px #EFEFEF solid",
                  fontFamily: proximanova_light,
                }}
              ></Form.Control>
            </Form.Group>

            {this.props.accountSetupError !== "" && (
              <div
                style={{
                  color: "#f34",
                  marginTop: 10,
                  paddingLeft: 10,
                  marginBottom: 10,
                }}
              >
                {this.props.accountSetupError}
              </div>
            )}

            {this.props.loading && <div> Creating Account...</div>}
            <button
              className="login_button"
              style={{
                marginTop: "10px",
                color: "white",
                fontSize: "20px",
                backgroundColor: "#2d506c",
                padding: "10px",
                width: "190px",
                letterSpacing: "2.5px",
              }}
              type="Submit"
            >
              SUBMIT
            </button>
          </div>
        </Form>

        <br />
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            width: "50vw",
            marginBottom: "30px",
          }}
        >
          <Link
            to={"/login"}
            style={{
              color: "#2d506c",
              textDecoration: "none",
              fontFamily: proximanova_light,
            }}
          >
            LOGIN{" "}
          </Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  email: state.account.email,
  password1: state.account.password1,
  password2: state.account.password2,
  token: state.auth.token,
  displayName: state.account.displayName,
  accountSetupError: state.account.error,
  loading: state.account.loading,
});

export default withRouter(
  connect(mapStateToProps, {
    onASEmailChange,
    onASPassword1Change,
    onASPassword2Change,
    onASNameChange,
    attemptAccountSetup,
    onASClearFields,
    addToken,
    onASError,
  })(SignUp)
);
